import { useEffect, useRef, useState } from 'react';
import { fetchCampaignPermissions } from '../services/callcenterV2/campaignsService';
import { getCcv2TenantId } from '../services/callcenterV2';

const CACHE_TTL_MS = 30_000;

let cache = null;

export function clearCampaignPermissionsCache() {
  cache = null;
}

export function useCampaignPermissions({ enabled = true } = {}) {
  const tenantId = getCcv2TenantId();
  const [state, setState] = useState(() => {
    if (cache && cache.tenantId === tenantId && cache.expiresAt > Date.now()) {
      return { canManage: cache.canManage, role: cache.role, loading: false };
    }
    return { canManage: false, role: null, loading: enabled };
  });
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    if (!enabled) {
      setState({ canManage: false, role: null, loading: false });
      return () => {
        mounted.current = false;
      };
    }

    if (cache && cache.tenantId === tenantId && cache.expiresAt > Date.now()) {
      setState({ canManage: cache.canManage, role: cache.role, loading: false });
      return () => {
        mounted.current = false;
      };
    }

    setState((prev) => ({ ...prev, loading: true }));

    fetchCampaignPermissions()
      .then((data) => {
        const canManage = Boolean(data && data.canManage);
        const role = (data && data.role) || null;
        cache = { tenantId, canManage, role, expiresAt: Date.now() + CACHE_TTL_MS };
        if (mounted.current) setState({ canManage, role, loading: false });
      })
      .catch(() => {
        if (mounted.current) setState({ canManage: false, role: null, loading: false });
      });

    return () => {
      mounted.current = false;
    };
  }, [tenantId, enabled]);

  return state;
}
